import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import { useRoute } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import { StyleSheet, View, Text, ScrollView } from "react-native";
import { s } from "@utils/metrics_1";
import RNCarousel from "react-native-looped-carousel";
import color from "@constants/color";
import LottieView from "lottie-react-native";
import isArrayCheck from "@utils/isArray";
import { fetchCustomerComplaints } from "@services/api";
import t from "@constants/localization";
import analytics from "@services/analytics";
import { SHOP_PERFORMANCE_EVENTS } from "@constants/analyticsEventsCT";
import ComplaintCard from "./ComplaintCard";

const PATH = "screens/CustomerComplaint";

const CustomerComplaint = (props) => {
  const { navigation } = props;
  const route = useRoute();
  const [complaintData, setComplaintData] = useState({});

  useEffect(() => {
    const getComplaintData = async () => {
      try {
        const { data } = await fetchCustomerComplaints();
        setComplaintData(data);
      } catch (error) {
        console.log("Error : ", error);
      }
    };
    getComplaintData();
    analytics.trackEvent(SHOP_PERFORMANCE_EVENTS.COMPLAINT_PAGE_LANDED);
  }, []);

  const renderCarousel = (item) => (
    <View
      style={[
        styles.card,
        { backgroundColor: item?.bgColor || "rgba(0, 171, 89, 0.08)" },
      ]}
    >
      <Text style={styles.cardText}>{item?.text}</Text>
    </View>
  );
  return (
    <View style={styles.container}>
      <HeaderWithBackAndTitle
        headerColor={color.white}
        headertitle={t(`${PATH}/header`)}
        navigation={navigation}
        route={route}
        hideShadow={true}
        isTransparent={false}
        headerStyle={styles.headerStyle}
      />
      {isArrayCheck(complaintData?.customer_complaints).length === 0 ? (
        <View style={styles.emptyContainer}>
          <LottieView
            source={require("../../assets/anim/happy_stars.json")}
            autoPlay
            loop
            style={{
              height: 180,
            }}
          />
          <Text style={styles.emptyText}>{t(`${PATH}/emptyListText`)}</Text>
          <Text style={styles.emptySubText}>
            {t(`${PATH}/emptyListSubText`)}
          </Text>
        </View>
      ) : (
        <ScrollView showsVerticalScrollIndicator={false} style={{ flex: 1 }}>
          <View style={{ paddingHorizontal: s.m }}>
            <RNCarousel
              bullets={true}
              bulletStyle={styles.bullet}
              chosenBulletStyle={styles.chosenBullet}
              bulletsContainerStyle={styles.bulletsContainer}
              style={styles.carousel}
              autoplay={true}
              delay={3000}
              pageInfo={false}
            >
              {complaintData?.carousel?.map((item) => renderCarousel(item))}
            </RNCarousel>
            <ComplaintCard
              customer_complaints={complaintData?.customer_complaints}
            />
            <View style={{ height: 70 }} />
          </View>
        </ScrollView>
      )}
    </View>
  );
};

export default CustomerComplaint;

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    flex: 1,
  },
  emptyContainer: {
    height: "80%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  emptyText: {
    padding: s.xs,
    fontSize: 20,
    fontFamily: "Noto Sans Devanagari",
    color: color.mediumBlack,
    fontWeight: "700",
  },
  emptySubText: {
    padding: s.xs,
    fontSize: 16,
    fontFamily: "Noto Sans Devanagari",
    color: color.mediumBlack,
    fontWeight: "400",
    opacity: 0.56,
  },
  card: {
    borderRadius: 16,
    padding: s.xxl,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    overflow: "hidden",
    marginHorizontal: s.m,
  },
  cardText: {
    fontSize: 18,
    fontFamily: "Noto Sans Devanagari",
    color: "#6A6A6A",
    fontWeight: "700",
  },
  bullet: {
    height: s.s,
    width: s.s,
    backgroundColor: color.color_D9D9D9,
    borderRadius: 50,
    marginHorizontal: 3,
    borderWidth: 0,
  },
  chosenBullet: {
    height: s.s,
    width: s.xxl,
    backgroundColor: "rgba(228, 0, 70, 1)",
    borderRadius: 50,
    marginHorizontal: 3,
    borderWidth: 0,
  },
  bulletsContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    width: "100%",
    top: 90,
  },
  carousel: {
    height: 90,
    marginVertical: s.m,
    justifyContent: "center",
    marginBottom: 30,
  },
});
